<template>
  <div class="d-flex">
    <user-short class="pl-2" :user-id="+option.id === -1 ? '' : option.id" length="18"></user-short>
    <span class="pl-2 user-text" v-no-capture>{{ option.listLabel || option.label }}</span>
  </div>
</template>

<script>
import UserShort from '@/components/UserShort'

/**
 * This provides the template for the individual items in User filter dropdown
 */
export default {
  name: 'UserListItemTemplate',
  props: ['option'],
  components: {
    UserShort
  }
}
</script>

<style lang="scss" scoped></style>
